module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAATBJREFUWEftl71OwlAYht8PPQ3iFdhQA4u2Mxfi4OCgg4MDrnIdOLA46ODCgImDt2Hi3OqioaZegX89hg9KUtMY7CFpCQxfx9Of9znPl5O8JSz5oiXnY/UBgm2Li1hyh3HuJo0GEgDTR/4DnOddARADYkAMiAExIAbEQCEDkY1aUkbsCB+zSslCC0lgYxfr1t00+CfecyM8/oVYGEBQt464wj0wzqahhHMCtd1hfJOFKB3guYHq90hdAtSq6Hh/5w1+Evi0BW+krFtmvq+u6XbzBV/JeqkAv8qZHzZZnziv+MzuNqxj453UFYha6UhKAwBwwMwXADpeqK/zarrvqGMAXSI6BTAwNeq5TsEEwM8qN/0npCOZAHjFARzVn6XcBJGOxA31Yd6zRgOmoKL3BWAM83cNMMILOpMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ios-bookmark-outline.png
// module id = 2624
// module chunks = 2